/**
 * FY2026 Board-Approved Budget Ceiling
 *
 * Source: "Approved budget & Dept objectives.pdf" — board-signed FY26 envelope.
 * Granularity: parent department × annual.
 * This is the LEGAL CEILING. The system's job is to never let actuals + forecast
 * exceed these numbers without loud warning.
 *
 * Threshold: 100% (board number). Finance's internal goal is to remain under
 * 110%, but the ceiling check is at 100%.
 *
 * Note: Salaries and Budget (non-payroll) are tracked separately because hiring
 * and vendor decisions follow different approval paths.
 */

export const FY = 2026;

export const BOARD_APPROVAL_DATE = '2026-02-01'; // TODO: confirm exact board approval date

export const boardCeiling2026 = [
  {
    id: 'electrical_software',
    parentDept: 'Electrical & Software',
    owner: 'Pat Dubois',
    budget: 540_000,
    salaries: 825_000,
    total: 1_365_000,
    objectives: [
      '5 controllers ready for Georgia EFS in Q1-2026',
      '5 controllers ready for USA/CAN EFS in Q4-2026',
      'V&V for EFS studies completed',
    ],
  },
  {
    id: 'mechanical_rd',
    parentDept: 'Mechanical R&D',
    owner: 'Sam Rivera, Jordan Lee',
    budget: 1_015_000,
    salaries: 2_310_000,
    total: 3_325_000,
    objectives: [
      'Design Master Record & Design History File ready by end of Q1-2026',
      'Optimize manufacturing to achieve production of 150 pumps, or as otherwise approved by management',
    ],
  },
  {
    id: 'operations',
    parentDept: 'Operations',
    owner: 'Drew Santos',
    budget: 3_120_000,
    salaries: 1_955_000,
    total: 5_075_000,
    objectives: [
      'Build the capacity to produce >15 devices per month',
      'Production of 150 pumps, or as otherwise approved by management',
      'Supply V&V and EFS studies with no delay',
    ],
  },
  {
    id: 'it',
    parentDept: 'IT',
    owner: 'Lee Park',
    budget: 165_000,
    salaries: 92_000,
    total: 257_000,
    objectives: [],
  },
  {
    id: 'clinical_regulatory',
    parentDept: 'Clinical & Regulatory',
    owner: 'Sky Chen, Casey Nguyen',
    budget: 2_035_000,
    salaries: 1_080_000,
    total: 3_115_000,
    objectives: [
      'Get regulatory approval in Canada (ITA) and/or USA (IDE) for Feasibility Study',
      'Enroll at least 10 patients in Clinical Study with at least 80% success per CIP primary endpoints',
    ],
  },
  {
    id: 'quality',
    parentDept: 'Quality',
    owner: 'Casey Nguyen, Noor Patel',
    budget: 112_000,
    salaries: 94_000,
    total: 206_000,
    objectives: [
      'Demonstrate readiness to submit and conduct a U.S. pivotal IDE study through a FDA-compliant quality system, independently assessed',
    ],
  },
  {
    id: 'design_control_testing',
    parentDept: 'Design Control & Testing',
    owner: 'Casey Nguyen',
    budget: 3_180_000,
    salaries: 215_000,
    total: 3_395_000,
    objectives: ['Fully complete Design V&V for CAN/USA EFS by end of Q2-2026'],
  },
  {
    id: 'intellectual_property',
    parentDept: 'Intellectual Property',
    owner: 'Quinn Adams',
    budget: 645_000,
    salaries: 108_000,
    total: 753_000,
    objectives: [
      'Successfully achieve FTO with Design Freeze, ready for Series B capital raise',
      'File patent applications on all innovative aspects of the new pump design and related method',
    ],
  },
  {
    id: 'finances_legal',
    parentDept: 'Finances & Legal',
    owner: 'Alex Morgan, Taylor Brooks',
    budget: 612_000,
    salaries: 268_000,
    total: 880_000,
    objectives: [
      'Remain under 110% of approved budget',
      'Monthly reporting to investors',
      'Prepare Series B for closing in 2027 (full checklist completed)',
    ],
  },
  {
    id: 'people_culture',
    parentDept: 'People & Culture',
    owner: 'Alex Morgan, Riley Scott',
    budget: 222_000,
    salaries: 93_000,
    total: 315_000,
    objectives: ['Build a structure of HR capable to manage 100 people'],
  },
  {
    id: 'executive',
    parentDept: 'Executive',
    owner: 'Alex Morgan',
    budget: 184_000,
    salaries: 408_000,
    total: 592_000,
    objectives: ['Board, Investors, CEO'],
  },
  {
    id: 'commercial',
    parentDept: 'Commercial',
    owner: 'TBD',
    budget: 0,
    salaries: 0,
    total: 0,
    objectives: [],
    note: 'Not staffed in FY26. First commercial hires planned 2029 (Chief Commercial Officer Jun 2029, VP Marketing Aug 2029).',
  },
];

export const boardCeiling2026Totals = {
  budget: boardCeiling2026.reduce((s, d) => s + d.budget, 0),
  salaries: boardCeiling2026.reduce((s, d) => s + d.salaries, 0),
  total: boardCeiling2026.reduce((s, d) => s + d.total, 0),
};
